<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="close-container">
      <button @click="close" class="delete close-button" aria-label="close"></button>
    </div>
    <aside class="modal-card">
      <iframe src="https://players.brightcove.net/6019218630001/bLz4bOgEu_default/index.html?videoId=6128452019001" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </aside>
  </div>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'
import componentState from '@/mixins/component-state'

export default {
  mixins: [componentState],
  components: {
    ModalCustom
  },
  created: function () {
    this._callback('lockScrolling')
  },
  computed: {
    active: function () {
      return this.$store.getters.modalIsVisible('learnmore')
    }
  },
  methods: {
    close: function () {
      this.$store.dispatch('hideLearnMoreModal')
      this._callback('unlockScrolling')
      this.$emit('close')
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $modal-body-color: #F2F2F2;
  $close-icon-color: #1A051D;
  .modal-card iframe {
    height: 100%;
    width: 100%;
  }

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    width: 90%;
    height: 65vh;
    margin:0 auto;
    text-align:center;
    overflow:hidden;
    max-width:178vh;
    @include mobile{
      height: 50vh
    }
    @include fullhd {
      height: 80vh;
    }
    @media only screen
      and (min-device-width: 320px)
      and (max-device-width: 768px)
      and (-webkit-min-device-pixel-ratio: 2)
      and (orientation: landscape) {
        height: 65vh;
        width: 80%;
    }
  }
  .close-container {
    width: 90%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

</style>
